import { render, staticRenderFns } from "./OpportunitiesHedbergTable.vue?vue&type=template&id=1d4ca551&"
import script from "./OpportunitiesHedbergTable.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesHedbergTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports